export default "__VITE_ASSET__9cdbed65__"